import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Paper,
  AppBar,
  Tabs,
  Tab,
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { LoadingButton } from "@mui/lab";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import SwipeableViews from "react-swipeable-views";
import { useParams } from "react-router-dom";
import { useTheme } from "@emotion/react";
import Div from "@jumbo/shared/Div";
import ManualRapDialog from "./ManualRapDialog";

const initialValues = {
  ASK_DISC: false,
  GREEN_DISC: false,
  RED_DISC: false,
};
const ManageRapaport = () => {
  const swal = useSwalWrapper();
  const [loadingButon, setLoading] = useState(false);
  const handleSubmit = async (values) => {
    setLoading(true);
    await jwtAuthAxios
      .post("pricing/rapnetPriceUpdate", values)
      .then(() => {
        swal.fire({
          icon: "success",
          text: "Data inserted successfully",
        });
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
    // console.log(values); // Do something with the form values
  };
  return (
    <>
      <Card>
        <CardHeader
          title={<Typography variant="h4">Manage Rapaport</Typography>}
          subheader={
            <Typography sx={{ mt: 1, color: "text.secondary" }}>
              Plase Verify Detail Before Submittiong
            </Typography>
          }
        />
        <CardContent
          sx={{
            display: "flex",
            minWidth: 0,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: (theme) => theme.palette.action.hover,
          }}
        >
          <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            {({ values, handleChange }) => (
              <Form>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox checked={values.ASK_DISC} name="ASK_DISC" />
                    }
                    onChange={handleChange}
                    label="Adjust With Asking Disc Rate"
                  />
                  {/* <FormControlLabel
              control={<Checkbox checked={values.GREEN_DISC} name="GREEN_DISC" />}
              onChange={handleChange}
              label="Adjust With Asking Disc Rate"
            />
            <FormControlLabel
              control={<Checkbox checked={values.RED_DISC} name="RED_DISC" />}
              onChange={handleChange}
              label="Adjust With Asking Disc Rate"
            /> */}
                </FormGroup>
                <LoadingButton
                  loading={loadingButon}
                  sx={{ mt: 3 }}
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  Submit
                </LoadingButton>
              </Form>
            )}
          </Formik>
          {/* <LoadingButton variant='contained' color='primary'>Submit</LoadingButton> */}
        </CardContent>
      </Card>
    </>
  );
};

export const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
};
const TABRECIPIENT = { M: 1, R: 0 };
export const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Div sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Div>
      )}
    </div>
  );
};

const ManageRapaportModule = () => {
  const theme = useTheme();
  const { PTYPE } = useParams();
  const [value, setValue] = React.useState(TABRECIPIENT[PTYPE] || 0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };
 
  return (
    <Paper spacing={0} style={{ padding: 0 }}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab disabled={PTYPE} label="Manage Rapaport" {...a11yProps(0)} />
          <Tab disabled={PTYPE} label="Manual Rap Dialog" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <ManageRapaport  />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
           <ManualRapDialog /> 
        </TabPanel>
      </SwipeableViews>
    </Paper>
  );
};

ManageRapaportModule.Modulename = "managerapaport";
export default ManageRapaportModule;
